import styles from "./styles.module.css";

import Container from "components/grid/container";

const NotFound = () => {
  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.imageWrapper}>
          <h1 className={styles.title}>
            404 - Aradığınız Sayfa
            <span>Bulunamadı</span>
          </h1>
          <img className={styles.icon} src="/assets/icons/not-found.svg" alt="Sayfa Bulunamadı" />
        </div>
      </Container>
    </div>
  );
};

export default NotFound;
